<div class="card rounded-3 shadow border-gray">
  <div class="card-body">
    <h5 class="card-title fw-bold fs-5 mb-3">{{ 'navigation.contact' | translate }}</h5>
    <div class="info d-flex flex-column gap-3">
      <div class="d-flex gap-2">
        <i class="inm-icon-address yellow-text fs-6"></i>
        <div class="d-flex flex-column">
          <h5 class="mb-0 fw-bold">{{ 'direccion' | translate }}</h5>
          <span class="mb-0">{{ addressFull() }}</span>
        </div>
      </div>
      <div class="d-flex gap-2">
        <i class="inm-icon-phone yellow-text fs-6"></i>
        <div class="d-flex flex-column">
          <h5 class="mb-0 fw-bold">{{ 'components.register_form.phone' | translate }}</h5>
          <a class="dark-blue-text" href="tel:{{ phone() }}">
            <span>{{ phone() }}</span>
          </a>
        </div>
      </div>
      <div class="d-flex gap-2">
        <i class="inm-icon-email yellow-text" style="font-size: 13px"></i>
        <div class="d-flex flex-column">
          <h5 class="mb-0 fw-bold">{{ 'contact.email' | translate }}</h5>
          <a class="dark-blue-text" href="mailto:{{ email() }}">
            <span>{{ email() }}</span>
          </a>
        </div>
      </div>
      <div class="d-flex gap-2">
        <i class="inm-icon-web yellow-text fs-6"></i>
        <div class="d-flex flex-column">
          <h5 class="mb-0 fw-bold">{{ 'contact.website' | translate }}</h5>
          <a class="dark-blue-text" [href]="website()" target="_blank">
            <span class="break-all">{{ website() }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
